var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "container-input" }, [
        _c("div", { staticClass: "input-header" }, [
          _c("strong", [
            _vm._v(
              "Etapa " +
                _vm._s(_vm.nStepsBefore) +
                " de " +
                _vm._s(_vm.nRootSteps) +
                " - Selecione " +
                _vm._s(_vm.onlySameDate ? "o" : "data e") +
                " horário da atividade " +
                _vm._s(_vm.value.nome)
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-body" }, [
          _vm.value.initial_dates.length > 0
            ? _c(
                "div",
                [
                  !_vm.onlySameDate
                    ? _c(
                        "div",
                        [
                          _vm.value.use_calendario
                            ? _c("input-data-calendario", {
                                attrs: {
                                  "passeio-id": _vm.value.id,
                                  "initial-available-days": JSON.stringify(
                                    _vm.value.initial_dates
                                  ),
                                  "calendar-size": _vm.calendarSizeParsed,
                                  "start-opened": true,
                                },
                                on: { "on-open-change": _vm.heightChange },
                                model: {
                                  value: _vm.selectedDate,
                                  callback: function ($$v) {
                                    _vm.selectedDate = $$v
                                  },
                                  expression: "selectedDate",
                                },
                              })
                            : _c("input-data-lista", {
                                attrs: {
                                  "passeio-id": _vm.value.id,
                                  "available-days": JSON.stringify(
                                    _vm.value.initial_dates
                                  ),
                                  "return-days": JSON.stringify(
                                    _vm.value.initial_return_dates
                                  ),
                                  "primary-color": _vm.primaryColor,
                                },
                                model: {
                                  value: _vm.selectedDate,
                                  callback: function ($$v) {
                                    _vm.selectedDate = $$v
                                  },
                                  expression: "selectedDate",
                                },
                              }),
                        ],
                        1
                      )
                    : _c("div", [
                        _c("div", { staticClass: "container-date-selected" }, [
                          _c("div", { staticStyle: { "font-size": "14px" } }, [
                            _c("i", {
                              staticClass: "fa-solid fa-calendar-days",
                            }),
                            _vm._v("  \n              "),
                            _c("span", { staticStyle: { color: "#757575" } }, [
                              _vm._v(_vm._s(_vm.selectedDateDescription)),
                            ]),
                          ]),
                        ]),
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.loadingAvailability,
                          expression: "loadingAvailability",
                        },
                      ],
                      staticStyle: {
                        "text-align": "center",
                        "margin-top": "10px",
                      },
                    },
                    [_c("i", { staticClass: "fa-regular fa-hourglass" })]
                  ),
                  _vm._v(" "),
                  _c("input-horario", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.loadingAvailability && _vm.selectedDate,
                        expression: "!loadingAvailability && selectedDate",
                      },
                    ],
                    staticStyle: { "margin-top": "20px" },
                    attrs: {
                      value: _vm.selectedAvailabilityId,
                      horarios: _vm.horarios,
                      "selected-quantities": _vm.selectedAgeRanges,
                      "primary-color": _vm.primaryColor,
                      "show-remaining-vacancies": _vm.showRemainingVacancies,
                      "passeio-tipo": _vm.value.tipo_passeio,
                      "titulo-atividade": _vm.tituloAtividade,
                      "genero-titulo-atividade": _vm.generoTituloAtividade,
                      "is-mobile": _vm.isMobile,
                    },
                    on: {
                      "max-vagas-changed": (v) => (_vm.maxVagas = v),
                      "hora-changed": _vm.inputHora,
                    },
                  }),
                  _vm._v(" "),
                  _vm.quantidadePessoas > _vm.maxVagas &&
                  !_vm.loadingAvailability &&
                  _vm.selectedDate
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" },
                        },
                        [
                          _vm._v(
                            "\n          Não existem vagas suficientes para a quantidade de pessoas selecionadas.\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.scheduleErrorMessage
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.scheduleErrorMessage) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c("div", [_c("i", [_vm._v("Nenhuma data disponível")])]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { class: { "optionals-margins-mobile": _vm.isMobile } },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loadingOptionals,
                    expression: "loadingOptionals",
                  },
                ],
                staticStyle: { "text-align": "center", "margin-top": "10px" },
              },
              [_c("i", { staticClass: "fa-regular fa-hourglass" })]
            ),
            _vm._v(" "),
            _c("input-opcionais", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectedDate,
                  expression: "selectedDate",
                },
              ],
              staticStyle: { "margin-top": "20px" },
              attrs: {
                "selected-date": _vm.selectedDate,
                max: _vm.nPessoas,
                "primary-color": _vm.primaryColor,
                "mobile-mode": _vm.isMobile,
                "passeio-id": _vm.value.id,
                moeda: _vm.moeda,
              },
              on: {
                "is-loading": (v) => (_vm.loadingOptionals = v),
                "optionals-availability-change": (v) => (_vm.hasOptionals = v),
              },
              model: {
                value: _vm.selectedOptionals,
                callback: function ($$v) {
                  _vm.selectedOptionals = $$v
                },
                expression: "selectedOptionals",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("nav-buttons", {
        style: { "margin-top": _vm.isMobile ? "0px" : "20px" },
        attrs: {
          "disable-previus": false,
          "disable-next": _vm.disableGoNext,
          loading: _vm.loadingOptionals,
          "is-mobile": _vm.isMobile,
          "sub-total": _vm.subTotal,
          moeda: _vm.moeda,
        },
        on: { next: _vm.next, previus: _vm.previus },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }